import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  Legend,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useTranslation from "../../hooks/useTranslation";
import StatsCards from "./StatsCards";
import ReportsPanel from "./ReportsPanel";
import UpcomingAppointmentsCard from "./UpcomingAppointmentsCard";
import HighRiskPatientsCard from "./HighRiskPatientsCard";

export default function DashboardPage({ doctors, patients, sessions, appointments, reportFilter, setReportFilter }) {
  const { t } = useTranslation();
  const totalDoctors = doctors.length;
  const totalPatients = patients.length;
  const highRiskCount = patients.filter(p => p.status === "High Risk").length;

  const doctorLoadData = doctors.map(d => ({ name: (d.display_name || d.user_name).replace('Dr. ', ''), patients: d.patient_count || 0 }));
  return (
    <div className="admin-content">
      <StatsCards totalDoctors={totalDoctors} totalPatients={totalPatients} sessionsCount={sessions.length} highRiskCount={highRiskCount} />
      <div className="admin-grid-2">
        <div className="admin-panel">
          <div className="admin-panel-title">{t('Doctor Performance / Load Balance')}</div>
          <div className="admin-chart" style={{ width: '100%', height: 260 }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={doctorLoadData} margin={{ top: 8, right: 12, left: 0, bottom: 40 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  angle={-45}
                  textAnchor="end"
                  height={60}
                  tick={{ fontSize: 11, fill: '#374151' }}
                  interval={0}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="patients" name={t('Patients')} fill="#60a5fa" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <ReportsPanel reportFilter={reportFilter} setReportFilter={setReportFilter} sessions={sessions} appointments={appointments} patients={patients} />
      </div>
      <UpcomingAppointmentsCard appointments={appointments} />
      <HighRiskPatientsCard patients={patients} />
    </div>
  );
}
